import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["menuItem"]

  connect(){
    this.getOrCreateMoreDropdown;
  }

  toggle(event) {
    // This wasn't needed since we get it automatically from using the dropdown-anchor class
    //this.menuItemTarget.classList.toggle("active");
    // Kept here only if we want to do something more when toggling the more menu
  }

  get getOrCreateMoreDropdown() {
    // If we want to be able to get it again, turn's out it wasn't needed right now
    // var more_menu = document.getElementById("more-menu");
    // if (more_menu) { return more_menu; }
    var more_menu = document.getElementById("user-dropdown").nextElementSibling.cloneNode(true)
    more_menu.id = "more-menu";
    return this.menuItemTarget.insertAdjacentElement('afterend', more_menu);
  }
}